import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/data-table-bootstrap4.css";
import "./assets/css/sidebar.css";
import "./assets/css/style.css";
import "./assets/css/index.css";
import "tippy.js/dist/tippy.css";
import "./assets/css/react-calender.css";
import "./assets/css/tippy.css";
import "./assets/css/chat.css";
import "./assets/css/calender-custom.css";
import "./assets/css/admin-style.css";

ReactDOM.render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more About service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
